var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.998 12c.514 0 .937.383.995.883L18 13c0 .552-.456 1-1.002 1H7.002C6.45 14 6 13.556 6 13c0-.552.456-1 1.002-1h9.996zM2.99 12c.517 0 .944.383 1.002.883L4 13c0 .552-.443 1-1.01 1H1.01C.451 14 0 13.556 0 13c0-.552.443-1 1.01-1h1.98zm14.007-6c.514 0 .937.383.995.883L18 7c0 .552-.456 1-1.002 1H7.002C6.45 8 6 7.556 6 7c0-.552.456-1 1.002-1h9.996zM2.99 6c.517 0 .944.383 1.002.883L4 7c0 .552-.443 1-1.01 1H1.01C.451 8 0 7.556 0 7c0-.552.443-1 1.01-1h1.98zm14.007-6c.514 0 .937.383.995.883L18 1c0 .552-.456 1-1.002 1H7.002C6.45 2 6 1.556 6 1c0-.552.456-1 1.002-1h9.996zM2.99 0c.517 0 .944.383 1.002.883L4 1c0 .552-.443 1-1.01 1H1.01C.451 2 0 1.556 0 1c0-.552.443-1 1.01-1h1.98z",
    transform: "translate(-20 -157) translate(20 157) translate(5 7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.8df2da3fa480f4b778eacdeb9c00ea67.svg";
export { ForwardRef as ReactComponent };